<template>
  <div>
    <component
      v-if="hasNotBlockComponent(uiBlockComponent)"
      :is="isDecoration(data.style) ? 'v-card' : 'div'"
      :style="getStyleObject(data.style)"
      v-bind="bindProperties(data)"
    >
      <!-- :style="isDecoration(data.style) ? getStyleObject(data.style) : false" -->
      <component
        :is="uiBlockComponent"
        :blockField="data"
      >
        <template v-for="(key, propertyName, index) in data" :slot="propertyName" slot-scope="props">
          <template v-if="data[propertyName].type == 'image'">
            <img
              :src="data[propertyName].data + `&w=640&h=300&fit=crop`"
              alt="image"
            />
            <!--<svgfremcast name="drone" :original="true" ></svgfremcast>-->
          </template>
          <template v-else-if="data[propertyName].type == 'html'">
            <div v-html="data[propertyName].data">
            </div>
          </template>
          <template v-else-if="data[propertyName].type == 'icon'">
            <v-icon :color="data.style.inherit  ? css.fontColor : data.style.fontColor" :class="data[propertyName].data"></v-icon>
          </template>
          <template v-else-if="data[propertyName].type == 'title'">
            <span>{{ data[propertyName].data }}</span>
          </template>
          <template v-else-if="data[propertyName].type == 'video' && uiBlockComponent == 'videoBackground'">
            <video-block v-if="isDesktop" :id="data[propertyName].data"/>
            <v-img height="300" v-if="data[propertyName].cover || false" :src="data[propertyName].cover"/>
          </template>
          <template v-else-if="data[propertyName].type == 'video'">
            <video-block v-if="isDesktop" :id="data[propertyName].data"/>
          </template>
          <template v-else-if="data[propertyName].type == 'button'">
            <component
              :is="componentGlobalLoader('FieldButton')"
              :data="data[propertyName]"
              :styles="data.style"
              :defaultClassName="props.aClass"
            >
            </component>
          </template>
          <template v-else-if="data[propertyName].type == 'link'">
            <component
              :is="componentGlobalLoader('FieldButton')"
              :data="data[propertyName]"
              :styles="data.style"
              :css="css"
              :defaultClassName="props.aClass"
            >
            </component>
          </template>
          <template v-else-if="data[propertyName].type == 'videoCollection'">
            <component
              :is="componentGlobalLoader('VideoGrid')"
              v-bind="data.videoCollection"
              :id="id"
              :blockIndex="blockIndex"
              :theme="theme"
              :sectionId="sectionId"
              :settings="settings"
            >
            </component>
          </template>
          <template v-else>
            <p v-html="data[propertyName].data"/>
          </template>
        </template>
      </component>
    </component>
    <component
      v-else-if="getBlockComponent(uiBlockComponent)"
      :is="componentGlobalLoader(uiBlockComponent)"
      :data="data"
      :id="id"
      :blockIndex="blockIndex"
      :theme="theme"
      :sectionId="sectionId"
      :settings="settings"
    >
    </component>
  </div>
</template>

<script>
  import settings from '@fremcast/section/mixins/section';
  import { StyledButton } from "./ButtonStyle";
  import Styles from "@fremcast/section/mixins/styles";
  import { VCard } from 'vuetify/lib'

  export default {
    name: "Block.vue",
    data() {
      return {
        hover: false,
        blockComponents: ['VideoCard', 'CoverCategory', 'HeroImage']
        //theme: 'skrn'
      };
    },
    props: {
      uiBlockComponent: String,
      data: Object,
      css: Object
    },
    components: {
      VCard,
      StyledButton,
      VideoBlock: () => import('./VideoBlock')
    },
    mixins: [
      settings,
      Styles
    ],
    computed: {
      isDesktop() {
        const lgUp = ['lgDown', 'xl']
        return lgUp.indexOf(this.$mq) > -1
      },
      isMobile() {
        const mdDown = ['mdDown', 'smDown', 'xsDown']
        return mdDown.indexOf(this.$mq) > -1
      }
    },
    methods: {
      hasNotBlockComponent(block) {
        return !(!!this.getBlockComponent(block))
      },
      getBlockComponent(block) {
        return !!this.blockComponents.find(name => name == block)
      },
      isDecoration(item) {
        return this.isCardOnBlock(item);
      },
      bindProperties(data) {
        const item = _.find(data, ['type', 'link'])

        if (typeof item === 'undefined') {
          return
        }

        return {
          ...this.getCardProperties(data.style),
          ...{href: item.url || '#'}
        }

        /*
        @todo: Use vue router if internal page.
        disabled atm since we need to reload the entire page to fetch the page info on Laravel

        if (item.urlInternal) {
          return {
            to: item.url || '#'
          }
        }
        */
      }
    }
  }
</script>
